<template>
	<div class="cartListMain">
		<!-- <div class="list">
			<div class="myvoteBox">
				<img src="images/cart_vote/myvote.png" class="myvote" />
			</div>
			<div class="tableTitle">
				<div class="num">电子会员卡名称</div>
				<div class="name">票数(张)</div>
			</div>
			<div class="cardVote">
				<span class="name">优卡</span>
				<div class="progress">
					<i :style="{width: '80%'}"></i>
				</div>
				<span class="count">100</span>
			</div>
		</div> -->
		<div class="list tougao">
			<div class="myvoteBox">
				<img src="images/cart_vote/tougao.png" class="myvote" />
			</div>
			<div class="tableTitle">
				<div class="num">电子会员卡名称</div>
				<div class="name">票数(张)</div>
			</div>
			<ul class="cardVoteList" v-if="voteList">
				<li v-for="(item,index) in voteList" :key="index">
					<div class="cardVote">
						<span class="name">{{ item.title }}</span>
						<div class="progress">
							<i :style="{width: countPercentage(item.count, voteList)}"></i>
						</div>
						<span class="count">{{ item.count }}</span>
					</div>
				</li>
			</ul>
			<!-- <div class="pageBtn">
				<input type="button" value="上一页" />
				<input type="button" value="下一页" />
			</div> -->
		</div>
		<div class="submitBtn">
			<input type="button" value="已投票" />
		</div>
	</div>
</template>

<script>
import { activityInfo } from '@/apis/vote'

export default {
	data() {
		return {
            info: null,
        }
    },
    mounted() {
        activityInfo({ id: this.activity_id }).then(res => {
            this.info = res.data
        })
	},
	computed: {
        // 投票活动id 由url传参获取
		activity_id() {
			if (this.$route.query.hasOwnProperty('id')) {
				return this.$route.query.id
			} else {
				return null
			}
        },
        // 会员卡名列表
        voteList() {
            if (this.info) {
                return this.info.info.sort((a, b) => {
                    return a.id - b.id 
                })
            } else {
                return []
            }
		},
	},
	methods: {
		// 计算百分比
		countPercentage(numerator, list) {
			var denominator = 0;
			list.forEach(item => {
				denominator += item.count
			});
			return (numerator/denominator)*100+'%';
		}
	},
}
</script>

<style scoped>
.cartListMain {
	min-height: 100%;
	background: url('../../../../public/images/cart_vote/card_list_bg.png')
		no-repeat;
	background-size: contain;
	background-color: #f9e7b7;
	padding-top: 77.867vw;
}

.list {
	width: 92vw;
	background-color: #fef9ec;
	margin: 0 auto;
	position: relative;
}

.list::before,
.list::after {
	content: '';
	width: 6.933vw;
	height: 6.4vw;
	background: url('../../../../public/images/cart_vote/jia.png') no-repeat;
	background-size: contain;
	position: absolute;
}

.list::before {
	top: -4.133vw;
	left: 16vw;
}

.list::after {
	top: -4.133vw;
	right: 16vw;
}

.tableTitle {
	height: 13.333vw;
	font-size: 3.733vw;
	color: #303133;
	display: flex;
	justify-content: space-between;
	line-height: 15.467vw;
	border-bottom: 1px solid #ffe6d0;
}

.tableTitle .num {
	text-align: center;
	margin-left: 5.2vw;
}

.tableTitle .name {
	width: 46vw;
}

.pageBtn {
	height: 17.3333vw;
	display: flex;
	justify-content: center;
	align-items: center;
}

.pageBtn > input[type='button'] {
	width: 18.4vw;
	height: 8vw;
	background-color: #fe591e;
	border-radius: 4vw;
	font-size: 3.467vw;
	color: #ffffff;
	border: none;
	outline: none;
	margin: 0 6vw;
}

.submitBtn {
	margin: 7.333vw auto 9vw;
	display: flex;
	align-items: center;
	justify-content: center;
}

.submitBtn input[type='button'] {
	width: 79.467vw;
	height: 12.533vw;
	background-color: #fbbf00;
	border-radius: 6.267vw;
	font-size: 4.8vw;
	color: #ffffff;
	border: none;
	outline: none;
    opacity: 0.4;
}

.myvote {
	width: 20.8vw;
	height: 5.067vw;
	display: block;
	margin: 5.467vw auto 0;
}

.tougao {
	/* margin-top: 8.533vw; */
}

.myvoteBox {
	overflow: hidden;
}

.cardVote {
	height: 13.2vw;
	box-sizing: border-box;
	padding: 0 5.2vw;
	display: flex;
	align-items: center;
}

.cardVote .name {
	width: 40.66vw;
	font-size: 3.733vw;
	color: #303133;
}

.progress {
	width: 29.333vw;
	height: 2.667vw;
	background-color: #edeff2;
	border-radius: 1.333vw;
}

.progress > i {
	/* width: 18.667vw; */
	height: 2.667vw;
	background-image: linear-gradient(90deg, #f0b860 0%, #ffe7c1 100%);
	background-blend-mode: normal, normal;
	border-radius: 1.333vw;
	display: block;
}

.cardVote .count {
	text-align: right;
	flex: 1;
	font-size: 3.733vw;
	color: #303133;
}

.cardVoteList>li:nth-of-type(2n) {
    background-color: #ffe6d0;
}
</style>
